// TradeLeaders.tsx
import { Heading } from '@components'
import { A } from '@solidjs/router'
import { type JSX, type ParentProps, Show } from 'solid-js'
import { css, cx } from 'styled-system/css'
import { Flex, Grid } from 'styled-system/jsx'
import { link } from 'styled-system/recipes'

export default function (
	props: ParentProps<{ title: string; link?: string; rightSlot?: JSX.Element }>,
): JSX.Element {
	return (
		<Grid gridTemplateRows="auto 1fr">
			<Flex
				justifyContent="space-between"
				alignItems="center"
			>
				<Show
					when={props.link}
					keyed
					fallback={<Heading size="md">{props.title}</Heading>}
				>
					<A
						href={props.link!}
						class={cx(
							link(),
							css({
								_hover: {
									color: 'tscGreen.10',
									textUnderlineOffset: 4,
								},
							}),
						)}
					>
						<Heading size="md">{props.title}</Heading>
					</A>
				</Show>
				<Show when={props.rightSlot}>{props.rightSlot}</Show>
			</Flex>
			{props.children}
		</Grid>
	)
}
